export default __webpack_public_path__ + "static/media/berlinmitte_dark.84588298.png";